import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

// import '@splidejs/splide/css';
// import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';

window.Splide = Splide;
window.SplideVideo = Video;

if (window.location.pathname === '/') {
    setTimeout(() => {
        document.querySelectorAll('[x-ref="splide"] a').forEach((element) => {
            element.addEventListener('click', (event) => {
                const href = element.getAttribute('href');
                const match = href.match(/\/detail\/(\d+)-/)
                const parent = element.closest('[data-carousel]');

                if (match && match[1] && parent) {
                    window.dataLayer.push({
                        event: "HPCarouselClicked",
                        CarouselName: parent.getAttribute('data-carousel'),
                        PropertyId: match[1],
                        url: href.replace(window.location.origin, ''),
                    });
                }
            });
        });
    }, 3000);
}
